export const DOCUMENTATION_URL =
  'https://www.notion.so/ybknowledgebase/Creating-Workspace-in-Yieldbird-Platform-c25528c4e8b2412abcb05ac9b11a6d5b'
